import { Head, router } from '@inertiajs/react'
import React, { useState } from 'react'
import BasketSummary from './Components/BasketSummary'
import Header from './Components/Header'
import MenuList from './Components/MenuList'
import Toggle from './Components/Toggle'
import { useBasket } from './hooks/useBasket'
import Layout from './Layout'

export default function Food({ account, menu_items, basket: initialBasket, basket_items, sitting, sitting_label, offer_full_menu, takeaway: initialTakeaway, customer_notes: initialNotes, table_number, is_development }) {
  const { basket, addToBasket, removeFromBasket, updateQuantity, basketTotal, basketCount } = useBasket(initialBasket, menu_items, basket_items)
  const [takeaway, setTakeaway] = useState(table_number ? false : (initialTakeaway ?? false))
  const [customerNotes, setCustomerNotes] = useState(initialNotes || '')

  const handleNext = () => {
    // POST basket to update_basket, which will redirect to drinks
    // This follows the POST-Redirect-GET pattern
    router.post(`/${account.slug}/order/update-basket`, {
      basket: basket,
      takeaway: takeaway,
      customer_notes: customerNotes,
      next_page: 'drinks'
    })
  }

  return (
    <>
      <Head title={`Food Menu - ${account.name}`} />
      <Layout account={account}>
        <Header
        account={account}
        basketTotal={basketTotal}
        basketCount={basketCount}
        currentTab="food"
        basket={basket}
        basketItems={basket_items}
        menuItems={menu_items}
        onUpdateQuantity={updateQuantity}
        onCheckout={handleNext}
        isDevelopment={is_development}
        customerNotes={customerNotes}
        onNotesChange={setCustomerNotes}
      />

      <div className="pb-48">
        {!table_number && (
          <div className="px-4 pt-4 pb-2">
            <Toggle
              value={takeaway}
              onChange={setTakeaway}
              options={[
                { value: false, label: 'Sit in' },
                { value: true, label: 'Takeaway' }
              ]}
            />
          </div>
        )}

        <MenuList
          items={menu_items}
          basket={basket}
          onAdd={addToBasket}
          onRemove={removeFromBasket}
          sitting={sitting}
          sittingLabel={sitting_label}
          offerFullMenu={offer_full_menu}
          startCollapsed={!table_number}
          emptyLabel="No food items available for this time."
        />
      </div>

      <BasketSummary
        total={basketTotal}
        count={basketCount}
        onNext={handleNext}
        nextLabel="Choose drinks"
        allowSkip
        phoneNumber={account.phone}
      />
      </Layout>
    </>
  )
}
